import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import Ad from '@ifeng-fe/ui_pc_ad';
import { handleAd } from '@ifeng-fe/ui_pc_ad';
import { Event } from '@ifeng-fe/ui_base';
// 数据源
import { ListStore } from '../../store';
// 组件
import Details from '../Details';
import DramaSeries from '../DramaSeries';
import Gags from '../Gags';
import Recommend from '../Recommend';
// 热门评论
import HotComment from '../hotComment';
import Comment from './Comment';
import DramaListModal from './DramaListModal';
const event = new Event();

const Main = ({ content }) => {
    // 列表数据源
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { videoHeight, statusBarHeight, brandHeight, currentVideo, briefHeight } = listStates;
    const listRef = useRef();
    const adRef = useRef();
    // 设置节点尺寸（后续赋值给列表）
    const [listHeight, setHeight] = useState('');
    const [isShowDramaListModal, setIsShowDramaListModal] = useState(false); // 是否显示选集列表
    const [dramaList, setDramaList] = useState([]); // 选集列表
    const [dramaIndex, setDramaIndex] = useState(0); // 当前索引
    const isAndroid = navigator?.userAgent?.toLocaleLowerCase?.()?.includes('android');

    useEffect(
        () => {
            if (videoHeight) {
                // alert(videoHeight);
                // 强制异步列表计算高度，防止过早计算
                setTimeout(() => {
                    const windowHeight = window.outerHeight;
                    const videoAndStatusBarHeight = Number(videoHeight) + Number(statusBarHeight) + Number(brandHeight) + Number(briefHeight);
                    const height = windowHeight - videoAndStatusBarHeight;

                    setHeight(height);
                    changeListStates({ videoAndStatusBarHeight });
                }, 500);
            }
        },
        [videoHeight],
    );

    // 滚动置顶
    useEffect(
        () => {
            if (currentVideo && listRef.current) {
                console.log('视频切换');
                const domRef = listRef.current;

                domRef.scrollTop = 0;
            }
        },
        [currentVideo],
    );
    const handleScroll = e => {
        const dom = e.target;
        const num = dom.scrollTop;

        noTouch(num);
    };
    const noTouch = (num = 0) => {
        const isAndroid = window.grounds ? /android/i.test(window.grounds.getDeviceInfo().getOs()) : false;

        if (isAndroid) {
            const areas = [];
            const listWrapPositive = document.getElementById('listWrapPositive')?.getBoundingClientRect();

            const listWrapGags = document.getElementById('listWrapGags')?.getBoundingClientRect();

            areas.push({
                top: Math.round(listWrapPositive.top - num),
                end: Math.round(listWrapPositive.bottom + num),
                type: 'relative',
            });

            if (listWrapGags) {
                areas.push({
                    top: Math.round(listWrapGags.top - num),
                    end: Math.round(listWrapGags.bottom + num),
                    type: 'relative',
                });
            }

            window.grounds.setNoSlideArea(
                JSON.stringify({
                    area: areas,
                    totalHeight: window.innerHeight,
                }),
            );
        }
    };

    const adRunInit = async () => {
        let ad = null;

        if (isAndroid) {
            ad = window.grounds ? content.androidClientBannerAd : content.androidShareBannerAd;
        } else {
            ad = window.grounds ? content.iosClientBannerAd : content.iosShareBannerAd;
        }

        if (ad && window?.grounds?.getUserInfo?.()?.getVipStatus?.() !== '1') {
            try {
                const callback = await handleAd(ad);

                callback(adRef.current, ad.data, event);
            } catch (e) {
                console.error(e);
            }

            try {
                event.trigger('changeDrama');
            } catch (e) {
                console.error(e);
            }
        }
    };

    useEffect(
        () => {
            if (listHeight) {
                setTimeout(() => {
                    noTouch();
                }, 1000);
                adRunInit();
            }
        },
        [listHeight],
    );

    useEffect(
        () => {
            // 选集更换
            event.trigger('changeDrama');
        },
        [dramaIndex],
    );

    const toggleIsShowDramaListModal = (list, index) => {
        if (!isShowDramaListModal) {
            if (list) {
                setDramaList(list);
            }
            if (index !== undefined) {
                setDramaIndex(index);
            }
        }
        setIsShowDramaListModal(!isShowDramaListModal);
    };

    return (
        <>
            <Comment />
            {listHeight ? (
                <div className={styles.wrap} style={{ height: listHeight ? `${listHeight}px` : '0px', overflowY: isShowDramaListModal ? 'hidden' : 'auto' }} ref={listRef} onScroll={handleScroll}>
                    {isShowDramaListModal && <DramaListModal toggle={toggleIsShowDramaListModal} list={dramaList} dramaIndex={dramaIndex} onChangeDramaIndex={setDramaIndex} />}
                    {/* 简介 */}
                    <Details content={content} />
                    {/* 选集/相关推荐 */}
                    <DramaSeries content={content} openDramaList={toggleIsShowDramaListModal} dramaIndex={dramaIndex} onChangeDramaIndex={setDramaIndex} />
                    {/* 客户端添加广告 */}
                    {/* {window.grounds ? <Ad content={adData} /> : null} */}
                    <div ref={adRef} className={styles.adjustFontStyle} />
                    {/* 花絮 */}
                    <Gags key={currentVideo.id} content={content} />
                    {/* 更多推荐 */}
                    <Recommend content={content} />
                    {/* 热门评论 */}
                    {!window.grounds ? <HotComment content={{ content }} /> : null}
                </div>
            ) : null}
        </>
    );
};

Main.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Main);
